export default(e,t)=>(e.defaultProps=t,e);